import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  getLocalStorageItem,
  notifyPromise,
  setLocalStorageItem,
} from "../../../Utils/Helper";
import {
  cryptoPaymentSuccess,
  cryptoPaymentFailure,
} from "../../Action/payments/cryptoPaymentAction";
import { CRYPTO_PAYMENT } from "../../Action/actionTypes";
import { loginSuccess } from "../../Action";

function* cryptoPaymentRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post(
        "/generate-deposit-crypto-payment-request",
        action?.payload?.payload
      )
    );
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      yield put(cryptoPaymentSuccess(data?.data));
     
      let oldUserData = getLocalStorageItem("userData");
      if (oldUserData) {
        oldUserData.isAnyPendingPayment = true
        oldUserData.pendingCryptoData = data?.data
        yield put(loginSuccess(oldUserData));
        yield call(
          setLocalStorageItem,
          "userData",
          JSON.stringify(oldUserData)
        );
      }

    } else {
      yield put(cryptoPaymentFailure());
    }
  } catch (error) {
    yield put(cryptoPaymentFailure());
  }
}

export function* watchCryptoPaymentAPI() {
  yield takeEvery(CRYPTO_PAYMENT, cryptoPaymentRequest);
}

export default function* rootSaga() {
  yield all([watchCryptoPaymentAPI()]);
}
